import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 align-items-center" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-8 fv-plugins-icon-container align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "fw-bold fs-6 mt-2 mb-3 text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_13 = { class: "my-2" }
const _hoisted_14 = ["onUpdate:modelValue", "id", "checked"]
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_20 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_21 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_22 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_29 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_30 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_31 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_38 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_39 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_40 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_47 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_48 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_49 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "row mb-6" }
const _hoisted_59 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_60 = { class: "col-lg-8 fv-row" }
const _hoisted_61 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_62 = { class: "d-flex fv-row" }
const _hoisted_63 = { class: "col-lg-4" }
const _hoisted_64 = { class: "card-header border-0 align-items-center" }
const _hoisted_65 = { class: "card-title m-0" }
const _hoisted_66 = { class: "fw-bolder m-0" }
const _hoisted_67 = { class: "collapse show" }
const _hoisted_68 = { class: "card-body border-top p-9" }
const _hoisted_69 = { class: "row mb-6" }
const _hoisted_70 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_71 = { class: "col-lg-4 fv-row" }
const _hoisted_72 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_73 = { class: "row mb-6" }
const _hoisted_74 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_75 = { class: "col-lg-4 fv-row" }
const _hoisted_76 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_77 = { class: "row mb-6" }
const _hoisted_78 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "col-lg-4 fv-row" }
const _hoisted_80 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_81 = { class: "row mb-6" }
const _hoisted_82 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "col-lg-4 fv-row" }
const _hoisted_84 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_85 = { class: "row mb-6" }
const _hoisted_86 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_87 = { class: "col-lg-4 fv-row" }
const _hoisted_88 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_89 = { class: "row mb-6" }
const _hoisted_90 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_91 = { class: "col-lg-4 fv-row" }
const _hoisted_92 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "col-lg-4" }
const _hoisted_94 = { class: "card-header border-0 align-items-center" }
const _hoisted_95 = { class: "card-title m-0" }
const _hoisted_96 = { class: "fw-bolder m-0" }
const _hoisted_97 = { class: "collapse show" }
const _hoisted_98 = { class: "card-body border-top p-9" }
const _hoisted_99 = { class: "row mb-6" }
const _hoisted_100 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_101 = { class: "col-lg-4 fv-row" }
const _hoisted_102 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_103 = { class: "row mb-6" }
const _hoisted_104 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_105 = { class: "col-lg-4 fv-row" }
const _hoisted_106 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_107 = { class: "row mb-6" }
const _hoisted_108 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_109 = { class: "col-lg-4 fv-row" }
const _hoisted_110 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_111 = { class: "row mb-6" }
const _hoisted_112 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_113 = { class: "col-lg-4 fv-row" }
const _hoisted_114 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_115 = { class: "col-lg-4" }
const _hoisted_116 = { class: "card-header border-0 align-items-center" }
const _hoisted_117 = { class: "card-title m-0" }
const _hoisted_118 = { class: "fw-bolder m-0" }
const _hoisted_119 = { class: "collapse show" }
const _hoisted_120 = { class: "card-body border-top p-9" }
const _hoisted_121 = { class: "row mb-3" }
const _hoisted_122 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_123 = { class: "col-lg-4 fv-row" }
const _hoisted_124 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_125 = { class: "row mb-3" }
const _hoisted_126 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_127 = { class: "col-lg-4 fv-row" }
const _hoisted_128 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_129 = { class: "row mb-3" }
const _hoisted_130 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_131 = { class: "col-lg-4 fv-row" }
const _hoisted_132 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_133 = { class: "row mb-3" }
const _hoisted_134 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_135 = { class: "col-lg-4 fv-row" }
const _hoisted_136 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_137 = { class: "row mb-3" }
const _hoisted_138 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_139 = { class: "col-lg-4 fv-row" }
const _hoisted_140 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_141 = { class: "row mb-3" }
const _hoisted_142 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_143 = { class: "col-lg-4 fv-row" }
const _hoisted_144 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_145 = { class: "row mb-3" }
const _hoisted_146 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_147 = { class: "col-lg-4 fv-row" }
const _hoisted_148 = { class: "col-lg-4 col-form-label fw-bold fs-6" }

import { showBackendError } from "@/assets/ts/_utils/ShowBackendError";
import tipoBolsaCuidados from "@/core/data/tipoBolsaCuidados";
import { BolsaCuidados } from "@/store/models";
import { AuthModule, ProyectosN2ListadoModule } from "@/store/modules";
import { ElNotification } from "element-plus";
import { ErrorMessage, useForm } from "vee-validate";
import { computed, onBeforeMount, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormState {
  servicioOtroEspecificar?: string | null;
  requisitosExigibles?: string | null;
  lugarPrestacion?: string | null;
  criteriosPreferentesAcceso?: string | null;
  costeServicio?: string | null;
  OTROS?: boolean | null;
  CUIDADOS_DOMICILIO?: boolean | null;
  DIAS_NO_LECTIVOS?: boolean | null;
  VACACIONES_ESCOLARES?: boolean | null;
  FIN_DE_SEMANA?: boolean | null;
  AMPLIACION_HORARIOS?: boolean | null;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const module = getModule(ProyectosN2ListadoModule, store);
const authModule = getModule(AuthModule, store);
const comarcaId = authModule.user.comarcaId;
const route = useRoute();
const token = route.params.id as string;

const bolsaCuidados = computed(() => module.proyectoN2?.bolsaCuidados);
const editingBolsaCuidados = ref<boolean>(false);
const showOtros = ref<boolean>(false);

const tipoServicios = computed(() => {
  if (bolsaCuidados.value?.tipoBolsaCuidados) {
    return bolsaCuidados.value?.tipoBolsaCuidados
      .map((tbc) => {
        if (tbc.id === "OTROS") {
          const otrosServiciosLabel = bolsaCuidados.value
            ?.servicioOtroEspecificar
            ? ": " + bolsaCuidados.value?.servicioOtroEspecificar
            : "";
          return tbc.nombre + otrosServiciosLabel;
        }
        return tbc.nombre;
      })
      .join("\n");
  }
  return "";
});

const proyectoTipoBolsaCuidados = computed(() => {
  return tipoBolsaCuidados.map((tbc) => {
    return {
      id: tbc.id,
      nombre: tbc.nombre,
      checked: bolsaCuidados.value?.tipoBolsaCuidados
        ? bolsaCuidados.value?.tipoBolsaCuidados.find((t) =>
            t.id === tbc.id ? true : false
          )
          ? true
          : false
        : false,
    };
  });
});

const schema = Yup.object({
  AMPLIACION_HORARIOS: Yup.bool().label(
    proyectoTipoBolsaCuidados.value?.find((p) => p.id === "AMPLIACION_HORARIOS")
      ?.nombre ?? ""
  ),
  DIAS_NO_LECTIVOS: Yup.bool().label(
    proyectoTipoBolsaCuidados.value?.find((p) => p.id === "DIAS_NO_LECTIVOS")
      ?.nombre ?? ""
  ),
  VACACIONES_ESCOLARES: Yup.bool().label(
    proyectoTipoBolsaCuidados.value?.find(
      (p) => p.id === "VACACIONES_ESCOLARES"
    )?.nombre ?? ""
  ),
  FIN_DE_SEMANA: Yup.bool().label(
    proyectoTipoBolsaCuidados.value?.find((p) => p.id === "FIN_DE_SEMANA")
      ?.nombre ?? ""
  ),
  CUIDADOS_DOMICILIO: Yup.bool().label(
    proyectoTipoBolsaCuidados.value?.find((p) => p.id === "CUIDADOS_DOMICILIO")
      ?.nombre ?? ""
  ),
  OTROS: Yup.bool().label(
    proyectoTipoBolsaCuidados.value?.find((p) => p.id === "OTROS")?.nombre ?? ""
  ),
  servicioOtroEspecificar: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.bolsaCuidados.campos.tipoServicio")),
  requisitosExigibles: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.bolsaCuidados.campos.requisitos")),
  lugarPrestacion: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.bolsaCuidados.campos.lugarPrestacion")),
  criteriosPreferentesAcceso: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.bolsaCuidados.campos.criterios")),
  costeServicio: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.bolsaCuidados.campos.coste")),
});

const { resetForm, handleSubmit, values, meta } = useForm<Partial<FormState>>({
  validationSchema: schema,
});

const guardaDetalle = ref<boolean>(false);
const guardarBolsaCuidados = handleSubmit(async (values) => {
  guardaDetalle.value = true;
  const initialValues = bolsaCuidados.value?.tipoBolsaCuidados
    ? bolsaCuidados.value?.tipoBolsaCuidados.map((tbc) => tbc.id)
    : [];

  initialValues?.forEach((tbc) => {
    if (Object.prototype.hasOwnProperty.call(meta.value.initialValues, tbc)) {
      if (meta.value.initialValues) {
        meta.value.initialValues[tbc] = true;
      }
    }
  });

  const update: Partial<BolsaCuidados> = {};
  if (meta.value.initialValues) {
    for (const key of Object.keys(meta.value.initialValues)) {
      if (values[key] === false) {
        update[key] = undefined;
      } else {
        update[key] = values[key] || meta.value.initialValues[key];
      }
    }
  }

  const tipoServiciosValues = Object.fromEntries(
    Object.entries(update).filter(
      ([key]) =>
        key == "AMPLIACION_HORARIOS" ||
        key == "DIAS_NO_LECTIVOS" ||
        key == "VACACIONES_ESCOLARES" ||
        key == "FIN_DE_SEMANA" ||
        key == "CUIDADOS_DOMICILIO" ||
        key == "OTROS"
    )
  );

  if (
    update.AMPLIACION_HORARIOS !== undefined ||
    update.DIAS_NO_LECTIVOS !== undefined ||
    update.VACACIONES_ESCOLARES !== undefined ||
    update.FIN_DE_SEMANA !== undefined ||
    update.CUIDADOS_DOMICILIO !== undefined ||
    update.OTROS !== undefined
  ) {
    update.tipoServicios = Object.keys(tipoServiciosValues).filter(
      (t) => tipoServiciosValues[t]
    );
    delete update.AMPLIACION_HORARIOS;
    delete update.DIAS_NO_LECTIVOS;
    delete update.VACACIONES_ESCOLARES;
    delete update.FIN_DE_SEMANA;
    delete update.CUIDADOS_DOMICILIO;
    delete update.OTROS;
  } else {
    update.tipoServicios = [];
  }

  const filteredValues = Object.fromEntries(
    Object.entries(update).filter(([, value]) => !!value)
  );
  if (Object.keys(filteredValues).length) {
    await module
      .patchBolsaCuidadosById({
        id: token,
        comarcaId: comarcaId,
        bolsaCuidados: {
          ...filteredValues,
        },
      })
      .then(() => {
        ElNotification({
          message: t("formulario.proyecto.bolsaCuidados.guardar.mensaje.exito"),
          type: "success",
        });
        editingBolsaCuidados.value = false;
        module.fetchById({ comarcaId: comarcaId, id: token as string });
      })
      .catch((err) => {
        if (typeof err === "object" && err?.error?.statusCode < 500) {
          showBackendError(t, err.error);
        } else {
          ElNotification({
            message: t("formulario.proyecto.bolsaCuidados.cargar.error"),
            type: "error",
          });
        }
      })
      .finally(() => {
        guardaDetalle.value = false;
      });
  } else {
    ElNotification({
      message: t("formulario.proyecto.bolsaCuidados.guardar.mensaje.exito"),
      type: "success",
    });
    editingBolsaCuidados.value = false;
    module.fetchById({ comarcaId: comarcaId, id: token as string });
    guardaDetalle.value = false;
  }
});

onBeforeMount(() => {
  // load();
});

watch(editingBolsaCuidados, () => {
  resetForm({
    values: {
      FIN_DE_SEMANA: bolsaCuidados.value?.tipoBolsaCuidados?.find(
        (t) => t.id === "FIN_DE_SEMANA"
      )?.checked,
      VACACIONES_ESCOLARES: bolsaCuidados.value?.tipoBolsaCuidados?.find(
        (t) => t.id === "VACACIONES_ESCOLARES"
      )?.checked,
      DIAS_NO_LECTIVOS: bolsaCuidados.value?.tipoBolsaCuidados?.find(
        (t) => t.id === "DIAS_NO_LECTIVOS"
      )?.checked,
      AMPLIACION_HORARIOS: bolsaCuidados.value?.tipoBolsaCuidados?.find(
        (t) => t.id === "AMPLIACION_HORARIOS"
      )?.checked,
      CUIDADOS_DOMICILIO: bolsaCuidados.value?.tipoBolsaCuidados?.find(
        (t) => t.id === "CUIDADOS_DOMICILIO"
      )?.checked,
      OTROS: bolsaCuidados.value?.tipoBolsaCuidados?.find(
        (t) => t.id === "OTROS"
      )?.checked,
      servicioOtroEspecificar: bolsaCuidados.value?.servicioOtroEspecificar,
      requisitosExigibles: bolsaCuidados.value?.requisitosExigibles,
      lugarPrestacion: bolsaCuidados.value?.lugarPrestacion,
      criteriosPreferentesAcceso:
        bolsaCuidados.value?.criteriosPreferentesAcceso,
      costeServicio: bolsaCuidados.value?.costeServicio,
    },
  });

  if (values.OTROS === undefined) {
    showOtros.value = bolsaCuidados.value?.tipoBolsaCuidados?.some(
      (t) => t.id === "OTROS"
    ) as boolean;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formulario.proyecto.bolsaCuidados.titulo")), 1)
      ]),
      (!editingBolsaCuidados.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (editingBolsaCuidados.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.editar.button")), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(guardarBolsaCuidados),
              loading: guardaDetalle.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.guardar.button")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (editingBolsaCuidados.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
              ]),
              _: 1
            })
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("bolsaCuidados.tipoServicio")), 1),
          _createElementVNode("div", _hoisted_11, [
            (!editingBolsaCuidados.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(tipoServicios) != "" ? _unref(tipoServicios) : "-"), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(proyectoTipoBolsaCuidados), (tipoServicio) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-check form-check-custom form-check-solid d-block",
                      key: tipoServicio.id
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((_unref(values)[tipoServicio.id]) = $event),
                          id: tipoServicio.id,
                          checked: tipoServicio.checked
                        }, null, 8, _hoisted_14), [
                          [_vModelCheckbox, _unref(values)[tipoServicio.id]]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: tipoServicio.id
                        }, _toDisplayString(tipoServicio.nombre), 9, _hoisted_15)
                      ])
                    ]))
                  }), 128)),
                  (
                  showOtros.value && _unref(values).OTROS === undefined
                    ? showOtros.value
                    : _unref(values).OTROS
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "servicioOtroEspecificar",
                            placeholder: "",
                            modelValue: _unref(values).servicioOtroEspecificar,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(values).servicioOtroEspecificar) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_unref(ErrorMessage), {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "servicioOtroEspecificar"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("formulario.proyecto.bolsaCuidados.campos.lugarPrestacion")), 1),
          (!editingBolsaCuidados.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(bolsaCuidados)?.lugarPrestacion ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "lugarPrestacion",
                      placeholder: "",
                      modelValue: _unref(values).lugarPrestacion,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(values).lugarPrestacion) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_unref(ErrorMessage), { name: "lugarPrestacion" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("formulario.proyecto.bolsaCuidados.campos.requisitos")), 1),
          (!editingBolsaCuidados.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(bolsaCuidados)?.requisitosExigibles ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "requisitosExigibles",
                      placeholder: "",
                      modelValue: _unref(values).requisitosExigibles,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(values).requisitosExigibles) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_unref(ErrorMessage), { name: "requisitosExigibles" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("formulario.proyecto.bolsaCuidados.campos.criterios")), 1),
          (!editingBolsaCuidados.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(bolsaCuidados)?.criteriosPreferentesAcceso ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "criteriosPreferentesAcceso",
                      placeholder: "",
                      modelValue: _unref(values).criteriosPreferentesAcceso,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(values).criteriosPreferentesAcceso) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_unref(ErrorMessage), { name: "criteriosPreferentesAcceso" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("formulario.proyecto.bolsaCuidados.campos.coste")), 1),
          (!editingBolsaCuidados.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(bolsaCuidados)?.costeServicio ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_el_input, {
                      type: "text",
                      name: "costeServicio",
                      placeholder: "",
                      modelValue: _unref(values).costeServicio,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(values).costeServicio) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_unref(ErrorMessage), { name: "costeServicio" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("formulario.proyecto.bolsaCuidados.campos.nPlazas")), 1),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(bolsaCuidados)?.nPlazas ?? "-"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("formulario.proyecto.bolsaCuidados.campos.nSolicitudes")), 1),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("label", _hoisted_61, _toDisplayString(_unref(bolsaCuidados)?.nSolicitudes ?? "-"), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("h3", _hoisted_66, _toDisplayString(_ctx.$t(
                  "formulario.proyecto.bolsaCuidados.campos.personasPorEdad.titulo"
                )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorEdad.personasPorEdadMenores3"
                  )), 1),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("label", _hoisted_72, _toDisplayString(_unref(bolsaCuidados)?.nPersonasMenores3 ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorEdad.menores3a6"
                  )), 1),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("label", _hoisted_76, _toDisplayString(_unref(bolsaCuidados)?.nPersonas3a6 ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorEdad.personasPorEdad7a9"
                  )), 1),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("label", _hoisted_80, _toDisplayString(_unref(bolsaCuidados)?.nPersonas7a9 ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorEdad.personasPorEdad10a12"
                  )), 1),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("label", _hoisted_84, _toDisplayString(_unref(bolsaCuidados)?.nPersonas10a12 ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorEdad.personasPorEdad13a16"
                  )), 1),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("label", _hoisted_88, _toDisplayString(_unref(bolsaCuidados)?.nPersonas13a16 ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorEdad.personasPorEdadNC"
                  )), 1),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("label", _hoisted_92, _toDisplayString(_unref(bolsaCuidados)?.nPersonasEdadNC ?? "0"), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_93, [
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("h3", _hoisted_96, _toDisplayString(_ctx.$t(
                  "formulario.proyecto.bolsaCuidados.campos.personasPorGenero.titulo"
                )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorGenero.personasPorGeneroMujer"
                  )), 1),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("label", _hoisted_102, _toDisplayString(_unref(bolsaCuidados)?.nPersonasMujer ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorGenero.personasPorGeneroVaron"
                  )), 1),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("label", _hoisted_106, _toDisplayString(_unref(bolsaCuidados)?.nPersonasVaron ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorGenero.personasPorGeneroOtro"
                  )), 1),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("label", _hoisted_110, _toDisplayString(_unref(bolsaCuidados)?.nPersonasOtro ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.personasPorGenero.personasPorGeneroNC"
                  )), 1),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("label", _hoisted_114, _toDisplayString(_unref(bolsaCuidados)?.nPersonasNC ?? "0"), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_115, [
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("h3", _hoisted_118, _toDisplayString(_ctx.$t("formulario.proyecto.bolsaCuidados.campos.familias.titulo")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_119, [
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.familias.familiaNumerosa"
                  )), 1),
              _createElementVNode("div", _hoisted_123, [
                _createElementVNode("label", _hoisted_124, _toDisplayString(_unref(bolsaCuidados)?.nFamiliasNumerosa ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("label", _hoisted_126, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.familias.familiaMonoparental"
                  )), 1),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("label", _hoisted_128, _toDisplayString(_unref(bolsaCuidados)?.nFamiliasMonoparental ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.familias.familiaRefugiada"
                  )), 1),
              _createElementVNode("div", _hoisted_131, [
                _createElementVNode("label", _hoisted_132, _toDisplayString(_unref(bolsaCuidados)?.nFamiliasRefugiada ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.familias.familiaVictima"
                  )), 1),
              _createElementVNode("div", _hoisted_135, [
                _createElementVNode("label", _hoisted_136, _toDisplayString(_unref(bolsaCuidados)?.nFamiliasVictima ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.familias.familiaOtrasCargas"
                  )), 1),
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("label", _hoisted_140, _toDisplayString(_unref(bolsaCuidados)?.nFamiliasOtrasCargas ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_141, [
              _createElementVNode("label", _hoisted_142, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.familias.familiaOtras"
                  )), 1),
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("label", _hoisted_144, _toDisplayString(_unref(bolsaCuidados)?.nFamiliasOtra ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_145, [
              _createElementVNode("label", _hoisted_146, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.bolsaCuidados.campos.familias.familiaNC"
                  )), 1),
              _createElementVNode("div", _hoisted_147, [
                _createElementVNode("label", _hoisted_148, _toDisplayString(_unref(bolsaCuidados)?.nFamiliasNC ?? "0"), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})